import { Component, Input, Output, EventEmitter } from '@angular/core';

import { IInvoiceModel } from './../../models/invoice.models';

@Component({
    selector: 'invoice-list',
    templateUrl: './invoiceList.template.html',
    host: {'class': 'invoice-list-component', id: 'sidebar-content'}
})

export class InvoiceListComponent {
    @Input()
    model: Array<IInvoiceModel> = new Array<IInvoiceModel>();

    @Input()
    selectedInvoiceId : string = null;

    @Input()
	showIndicator: boolean = false;

    @Output()
    onInvoiceSelect: EventEmitter<IInvoiceModel> = new EventEmitter<IInvoiceModel>();

    selectInvoice(invoice: IInvoiceModel): void {
        this.onInvoiceSelect.emit(invoice);
    }
}
